window.SITE_CONFIG = {
    SpouseName: "My Love",
    // Fallback to 'default' if no theme is provided
    theme: "default",
    // Optional: Hash for the secondary "App Password" lock screen
    appPasswordHash: "185f8db32271fe25f561a6fc938b2e264306ec304eda518007d1764826381969"
};

//# sourceMappingURL=repo.cba3cc5b.js.map
